import { Link } from "react-router-dom";
import "./header.css";
import SurvivalInteractive from "../../assets/Assetstest/Logo.png";
import { FaBars } from "react-icons/fa6";
import { AiOutlineClose } from "react-icons/ai";
import { useState, useContext } from "react";
import { UserContext } from "../../context/userContext";
import { GiTabletopPlayers } from "react-icons/gi";
import { IoExtensionPuzzleOutline } from "react-icons/io5";
import { MdOutlineForum } from "react-icons/md";
import { IoCreateOutline } from "react-icons/io5";
import { LuUserSquare2 } from "react-icons/lu";
import { IoLogOutOutline } from "react-icons/io5";
import { IoLogInOutline } from "react-icons/io5";

export const Header = () => {
  const [isNavShowing, setIsNavShowing] = useState(
    window.innerWidth > 800 ? false : true
  );
  const { currentUser } = useContext(UserContext);

  const closeNavBar = () => {
    setIsNavShowing(!isNavShowing);

    if (window.innerWidth < 800) {
      setIsNavShowing(false);
    }
  };

  return (
    <nav>
      <div className="container nav__container">
        <Link to={"/"} className="nav__logo" onClick={closeNavBar}>
          <img src={SurvivalInteractive} alt="SurvivalInteractive Logo" />
          <span className="drop1"></span>
          <span className="drop2"></span>
          <span className="drop3"></span>
        </Link>
        {currentUser ? (
          <ul className={`nav__menu ${isNavShowing ? "show" : ""}`}>
            <li>
              <Link to={`/profile/${currentUser.userId}`} onClick={closeNavBar}>
                <LuUserSquare2 />
                {currentUser?.userName || "Profile"}
              </Link>
            </li>
            <li>
              <Link to={"/create"} onClick={closeNavBar}>
                <IoCreateOutline />
                Create
              </Link>
            </li>
            <li>
              <Link to={"/forum"} onClick={closeNavBar}>
                <MdOutlineForum />
                Forum
              </Link>
            </li>
            <li>
              <Link to={"/players"} onClick={closeNavBar}>
                <GiTabletopPlayers />
                Players
              </Link>
            </li>
            <li>
              <Link to={"/about"} onClick={closeNavBar}>
                <IoExtensionPuzzleOutline />
                About
              </Link>
            </li>
            <li>
              <Link to={"/logout"} onClick={closeNavBar}>
                <IoLogOutOutline />
                Logout
              </Link>
            </li>
          </ul>
        ) : (
          <ul className={`nav__menu ${isNavShowing ? "show" : ""}`}>
            <li>
              <Link to={"/forum"} onClick={closeNavBar}>
                <MdOutlineForum />
                Forum
              </Link>
            </li>
            <li>
              <Link to={"/players"} onClick={closeNavBar}>
                <GiTabletopPlayers />
                Players
              </Link>
            </li>
            <li>
              <Link to={"/about"} onClick={closeNavBar}>
                <IoExtensionPuzzleOutline />
                About
              </Link>
            </li>
            <li className="nav__login">
              <Link to={"/login"} onClick={closeNavBar}>
                <IoLogInOutline />
                Login
              </Link>
            </li>
          </ul>
        )}
      </div>
      <button
        className="nav__toggle-btn"
        onClick={() => setIsNavShowing(!isNavShowing)}
      >
        {isNavShowing ? <AiOutlineClose /> : <FaBars />}
      </button>
    </nav>
  );
};
